import { render } from "./PrintDocuments.vue?vue&type=template&id=3d7ff476&scoped=true&ts=true"
import script from "./PrintDocuments.vue?vue&type=script&lang=ts"
export * from "./PrintDocuments.vue?vue&type=script&lang=ts"

import "./PrintDocuments.vue?vue&type=style&index=0&id=3d7ff476&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d7ff476"],['__file',"src/views/PrintDocuments.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d7ff476"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d7ff476', __exports__)) {
    api.reload('3d7ff476', __exports__)
  }
  
  module.hot.accept("./PrintDocuments.vue?vue&type=template&id=3d7ff476&scoped=true&ts=true", () => {
    api.rerender('3d7ff476', render)
  })

}


export default __exports__